//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const RestCcpService: FeatureFlag = {"Id":"RestCcpService","Label":"Use REST CCP webservice","Impact":"Use the REST version of CCP instead of the SOAP version. Required to use split-payment. Has issues with failed payment.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
